import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import { BottomNav } from "@/components/BottomNav";
import { Topbar } from "@/components/Topbar";

export function Layout() {
  return (
    <div className="min-h-screen bg-brand-light">
      <Sidebar />
      <div className="lg:pl-64">
        <Topbar />
        <main className="px-5 lg:px-8 py-6 pb-24 lg:pb-8 max-w-[1400px] mx-auto">
          <Outlet />
        </main>
      </div>
      <BottomNav />
    </div>
  );
}
